import { Component, ComponentFactoryResolver, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { GeneralService } from 'src/app/core/services/general/general.service';
import { CabeceraComponent } from 'src/app/shared/widgets/cabecera/cabecera.component';
import { CardsGeneralDosComponent } from 'src/app/shared/widgets/cards-general-dos/cards-general-dos.component';
import { CardsGeneralComponent } from 'src/app/shared/widgets/cards-general/cards-general.component';
import { CarrouselGeneralComponent } from 'src/app/shared/widgets/carrousel-general/carrousel-general.component';
import { CustomDiaryGeneralComponent } from 'src/app/shared/widgets/custom-diary-general/custom-diary-general.component';
import { CustomStatsGeneralComponent } from 'src/app/shared/widgets/custom-stats-general/custom-stats-general.component';
import { FormContactoComponent } from 'src/app/shared/widgets/form-contacto/form-contacto.component';
import { ListaDeLinksComponent } from 'src/app/shared/widgets/lista-de-links/lista-de-links.component';
import { PostComponent } from 'src/app/shared/widgets/post/post.component';
import { PrimeraFotoDestacadaComponent } from 'src/app/shared/widgets/primera-foto-destacada/primera-foto-destacada.component';
import { TextItemGeneralComponent } from 'src/app/shared/widgets/text-item-general/text-item-general.component';
import { VideoMasFormularioComponent } from 'src/app/shared/widgets/video-mas-formulario/video-mas-formulario.component';
import { HeaderLandingComponent } from '../../components/header-landing/header-landing.component';
import { PortadaComponent } from 'src/app/shared/widgets/portada/portada.component';
import { FacultadPortadaComponent } from 'src/app/shared/widgets/facultad-portada/facultad-portada.component';
import { BannerFacultdadComponent } from 'src/app/shared/components/banner-facultdad/banner-facultdad.component';
import { DesplegablesFacultdadComponent } from 'src/app/shared/components/desplegables-facultdad/desplegables-facultdad.component';
import { NuestraFacultadPrincipalComponent } from 'src/app/shared/components/nuestra-facultad-principal/nuestra-facultad-principal.component';
import { GaleriaImagenesVideosComponent } from 'src/app/shared/components/galeria-imagenes-videos/galeria-imagenes-videos.component';
import { FacultadAutoridadesComponent } from 'src/app/shared/widgets/facultad-autoridades/facultad-autoridades.component';
import { FacultadesContactoComponent } from 'src/app/shared/components/facultades-contacto/facultades-contacto.component';

@Component({
  selector: 'app-general-landing',
  templateUrl: './general-landing.component.html',
  styleUrls: ['./general-landing.component.scss']
})
export class GeneralLandingComponent implements OnInit {
  @Input() datos: any;
  @Input() article: any;
  @Input() postsRelations: any;
  @Input() carrer: string;
  @Input() carrerType: string;
  @Input() venue: string;
  @Input() carrerInfo: any;
  @Input() fare: string;
  @Input() type: number = 1;
  @Input() countFamily: number = 1;
  @Input() isNotice: boolean = false;
  @Input() isSinglePage: boolean = false;
  count = 0;
  data: any;
  language: any;
  arrayRowsSize: any;
  arrayRows: any[] = [];
  itemCarrouselHeader: any[] = [];
  title: string;
  path: string;
  pathMob: string;
  innerHTML = '';
  @ViewChild('componenteDinamico1', { read: ViewContainerRef }) viewContainerRef1: ViewContainerRef;
  @ViewChild('componenteDinamico2', { read: ViewContainerRef }) viewContainerRef2: ViewContainerRef;
  @ViewChild('componenteDinamico3', { read: ViewContainerRef }) viewContainerRef3: ViewContainerRef;
  @ViewChild('componenteDinamico4', { read: ViewContainerRef }) viewContainerRef4: ViewContainerRef;
  @ViewChild('componenteDinamico5', { read: ViewContainerRef }) viewContainerRef5: ViewContainerRef;
  @ViewChild('componenteDinamico6', { read: ViewContainerRef }) viewContainerRef6: ViewContainerRef;
  @ViewChild('componenteDinamico7', { read: ViewContainerRef }) viewContainerRef7: ViewContainerRef;
  @ViewChild('componenteDinamico8', { read: ViewContainerRef }) viewContainerRef8: ViewContainerRef;
  @ViewChild('componenteDinamico9', { read: ViewContainerRef }) viewContainerRef9: ViewContainerRef;
  @ViewChild('componenteDinamico10', { read: ViewContainerRef }) viewContainerRef10: ViewContainerRef;
  @ViewChild('componenteDinamico11', { read: ViewContainerRef }) viewContainerRef11: ViewContainerRef;
  @ViewChild('componenteDinamico12', { read: ViewContainerRef }) viewContainerRef12: ViewContainerRef;
  @ViewChild('componenteDinamico13', { read: ViewContainerRef }) viewContainerRef13: ViewContainerRef;
  @ViewChild('componenteDinamico14', { read: ViewContainerRef }) viewContainerRef14: ViewContainerRef;
  @ViewChild('componenteDinamico15', { read: ViewContainerRef }) viewContainerRef15: ViewContainerRef;
  @ViewChild('componenteDinamico16', { read: ViewContainerRef }) viewContainerRef16: ViewContainerRef;
  @ViewChild('componenteDinamico17', { read: ViewContainerRef }) viewContainerRef17: ViewContainerRef;
  @ViewChild('componenteDinamico18', { read: ViewContainerRef }) viewContainerRef18: ViewContainerRef;
  @ViewChild('componenteDinamico19', { read: ViewContainerRef }) viewContainerRef19: ViewContainerRef;
  @ViewChild('componenteDinamico20', { read: ViewContainerRef }) viewContainerRef20: ViewContainerRef;
  viewContainerRefs: any[] = []
  constructor(private componentFactoryResolver: ComponentFactoryResolver, public route: ActivatedRoute, public services: GeneralService) {
  }

  ngOnInit(): void {
    this.route.params.forEach((params: Params) => {
      this.language = params['language'];
    });

  }



  ngAfterViewInit() {
    if (this.datos['type'] == 'landing') {

      this.data = this.datos['pages'];
      this.arrayRowsSize = this.datos['pagesLength'];
      for (let i = 1; i < this.arrayRowsSize + 1; i++) {
        if (this.datos['pages'][i][0]['status']) {
          this.arrayRows.push(i);
          this.loadPageAt(i, this.datos['pages'][i][0].entityType);
        }
      }
    }
  }
  async loadPageAt(index: number, entityType: string) {
    if (this.data[index].length > 1) {
      this.services.getEntities(this.data[index][0]['route'] + '&locale=' + this.language).subscribe(data1 => {
        this.renderComponent(index, this.data[index][0], 8, data1)
        this.services.getEntities(this.data[index][1]['route'] + '&locale=' + this.language).subscribe(data2 => {
          this.renderComponent(index, this.data[index][1], 4, data2)
        });
      });
    } else {
      this.services.getEntities(this.data[index][0]['route'] + '&locale=' + this.language).subscribe(data1 => {
        this.renderComponent(index, this.data[index][0], 12, data1)
      });
    }


  }

  renderComponent(index: number, element: any, width: number, rawData: any, background?: string) {
    let info = rawData.data[0];
    const elementId = element.id || null;


    let componentType = element.entityType;
    if (componentType === 'CustomSocialNetwork') componentType = 'Cards';
    if (element.typeDisplay) componentType = element.typeDisplay;

    if (componentType === 'EntityList') {
      
      info.entityList.forEach((subElement: any) => {
        this.renderComponent(index, subElement, width, rawData, subElement.background);
      });
      return; 
    }
    switch (componentType) {
      case "Venue": {
        let factory = this.componentFactoryResolver.resolveComponentFactory(NuestraFacultadPrincipalComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.info = info;
        ref.location.nativeElement.classList.add('col-lg-' + width);
         break;
      }
      case "Gallery": {
        let factory = this.componentFactoryResolver.resolveComponentFactory(GaleriaImagenesVideosComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.info = info;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        break;
      }
      case "Authority": {
        let factory = this.componentFactoryResolver.resolveComponentFactory(FacultadAutoridadesComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.autoridadesLista = info.authority.authorities;
        ref.instance.autoridadPrincipal = info.authority.dean;
        ref.instance.color = info.venue.color;
        ref.instance.modal = false;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        break;
      }
      case "VenueContact": {
        let factory = this.componentFactoryResolver.resolveComponentFactory(FacultadesContactoComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.info = info;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        break;
      }
      case "Portada": {

        let factory = this.componentFactoryResolver.resolveComponentFactory(PortadaComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.data = info;
        ref.instance.marginTitle = 75;
        ref.instance.heightDesk = "";
        ref.instance.heightMob = "";
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.layerPathMob = info.cover?.pathMobileSuperpuesta;
        ref.instance.layerPath = info.cover?.pathSuperpuesta;
        break;

      }
      case 'NewCover': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(FacultadPortadaComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.data = info;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;
        }

      case 'Banner': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(BannerFacultdadComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.info = info;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;
      }
      case 'Accordion': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(DesplegablesFacultdadComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.info = info;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;
      }
      case 'HeaderSection': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(HeaderLandingComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);

        ref.instance.title = info.headerSection.title;
        ref.instance.pathMob = info.headerSection.pathMobile;
        ref.instance.path = info.headerSection.path;
        ref.instance.itemCarrouselHeader = (info.headerSection.headerSectionItem) ? info.headerSection.headerSectionItem.slice(0, 6) : [];
        ref.instance.opacity = info.headerSection.filterOpacity;

        ref.changeDetectorRef.detectChanges();
      }

        break;
      case 'Primera foto destacada': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(PrimeraFotoDestacadaComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.data = info['entityList'][0].entity;
        ref.instance.title = info['entityList'][0].title;
        ref.changeDetectorRef.detectChanges();
      }

        break;
      case 'Simple': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(CardsGeneralComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        if (width == 8) {
          ref.instance.numberCards = 3;
        }
        ref.instance.data = info.entityList[0].entity;
        ref.instance.title = info.entityList[0].title;
        ref.instance.background = background;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
      }

        break;
      case 'CustomPublication': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(CarrouselGeneralComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.data = info.publication;
        ref.instance.title = 'Publicaciones';
        ref.instance.background = background;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
      }

        break;
      case 'Noticias con resumen': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(PostComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.data = info.entityList[0].entity;
        ref.instance.title = info.entityList[0].title;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
      }

        break;
      case 'Carrousel':
        if (info.entityList[0].entity) {
          let factory = this.componentFactoryResolver.resolveComponentFactory(CarrouselGeneralComponent);
          let ref = (this.viewContainerRefA(index)).createComponent(factory);
          ref.instance.data = info.entityList[0].entity;
          ref.instance.title = info.entityList[0].title;
          ref.instance.background = background;
          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.changeDetectorRef.detectChanges();
        }
        break;
      case 'Cards':
        let factory = this.componentFactoryResolver.resolveComponentFactory(CardsGeneralDosComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.data = info.socialNetwork.socialNetworkItem;
        ref.instance.title = info.socialNetwork.title;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
        break;
      case 'Lista de links':
        if (info.entityList[0].entity) {
          const factory = this.componentFactoryResolver.resolveComponentFactory(ListaDeLinksComponent);
          const ref = (this.viewContainerRefA(index)).createComponent(factory);
          ref.instance.data = info.entityList[0].entity;
          ref.instance.title = info.entityList[0].title;
          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.instance.background = background;
          ref.changeDetectorRef.detectChanges();
        }
        break;

      case 'Video + Formulario (en ingles)':

        //si esto rompe posiblemente se tenga que cambiar de "linkCode" a "link_video" 
        if (info.entityList[0].linkCode) {

          const factory = this.componentFactoryResolver.resolveComponentFactory(VideoMasFormularioComponent
          );
          const ref = (this.viewContainerRefA(index)).createComponent(factory);
          ref.instance.linkCode = info.entityList[0].linkCode;
          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.instance.title = info.entityList[0].title;
          ref.instance.background = background;
          ref.instance.idioma = 'en';
          ref.instance.entityId = info.entityList[0].id;
          ref.changeDetectorRef.detectChanges();

        }
        break;
      case 'Video + Formulario (en español)':
        if (info.entityList[0].linkCode) {
          const factory = this.componentFactoryResolver.resolveComponentFactory(VideoMasFormularioComponent
          );
          const ref = (this.viewContainerRefA(index)).createComponent(factory);
          ref.instance.linkCode = info.entityList[0].linkCode;
          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.instance.title = info.entityList[0].title;
          ref.instance.background = background;
          ref.instance.entityId = info.entityList[0].id;
          ref.instance.idioma = 'es';
          ref.changeDetectorRef.detectChanges();

        }
        break;
      case 'TextItem': {

        const factory = this.componentFactoryResolver.resolveComponentFactory(TextItemGeneralComponent);
        const ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.data = info.title;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.i = index;
        ref.changeDetectorRef.detectChanges();

      }
        break;

      case 'CustomForm': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(FormContactoComponent);
        const ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();

      }
        break;
      case 'Diary': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(CustomDiaryGeneralComponent);
        const ref = (this.viewContainerRefA(index)).createComponent(factory);
        if (index == 2) {
          width = 4;
        }
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.data = info.diary[0].diaryItem;
        ref.instance.title = info.diary[0].title;
        ref.instance.width = width;
        ref.changeDetectorRef.detectChanges();

      }
        break;
      case 'CustomStats': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(CustomStatsGeneralComponent);
        const ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.data = info.CustomStats;
        ref.instance.width = width;
        ref.changeDetectorRef.detectChanges();

      }
        break;
      case 'Cabecera': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(CabeceraComponent);
        const ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.title = info.entityList[0].title;
        ref.instance.slider = info.entityList[0].entity;
        ref.instance.background = info.entityList[0].background;
        ref.instance.path = info.entityList[0].path;
        ref.instance.width = width;
        ref.instance.noticesLinkTitle = info.entityList[0].noticesLinkTitle;
        ref.instance.noticesLink = info.entityList[0].noticesLink.systemTitle;
        ref.instance.cabeceraButtons = info.entityList[0].cabeceraButtons;
        ref.changeDetectorRef.detectChanges();

      }
        break;


    }


  }

  /*definirComponentes(index: number, element: any, width: number, data1: any) {
    let info = data1.data[0];
    switch (element.entityType) {
      case "Portada":
        this.newComponent(index, 'Portada', info, width)

        break;
      case "HeaderSection":

        this.newComponent(index, 'HeaderSection', info, width)

        break;
      case "CustomSocialNetwork":
        this.newComponent(index, 'Cards', info, width)

        break;

      case "CustomPublication":
        this.newComponent(index, 'CustomPublication', info, width)

        break;

      case "TextItem":
        this.newComponent(index, 'TextItem', info, width)

        break;

      case 'EntityList':
        info.entityList.forEach(element => {
          let type = element.typeDisplay;
          var background = element.background;
          this.newComponent(index, type, info, width, background)
        });

        break;
      case "Diary":
        this.newComponent(index, 'Diary', info, width)

        break;
    }



  }
  newComponent(index: number, type: string, info: any, width: number, background?: string) {

    switch (type) {
      case "Portada": {

        let factory = this.componentFactoryResolver.resolveComponentFactory(PortadaComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.data = info;
        ref.instance.marginTitle = 75;
        ref.instance.heightDesk = "";
        ref.instance.heightMob = "";
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.layerPathMob = info.cover?.pathMobileSuperpuesta;
        ref.instance.layerPath = info.cover?.pathSuperpuesta;

      }


      case 'HeaderSection': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(HeaderLandingComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);

        ref.instance.title = info.headerSection.title;
        ref.instance.pathMob = info.headerSection.pathMobile;
        ref.instance.path = info.headerSection.path;
        ref.instance.itemCarrouselHeader = (info.headerSection.headerSectionItem) ? info.headerSection.headerSectionItem.slice(0, 6) : [];
        ref.instance.opacity = info.headerSection.filterOpacity;

        ref.changeDetectorRef.detectChanges();
      }

        break;
      case 'Primera foto destacada': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(PrimeraFotoDestacadaComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.data = info['entityList'][0].entity;
        ref.instance.title = info['entityList'][0].title;
        ref.changeDetectorRef.detectChanges();
      }

        break;
      case 'Simple': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(CardsGeneralComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        if (width == 8) {
          ref.instance.numberCards = 3;
        }
        ref.instance.data = info.entityList[0].entity;
        ref.instance.title = info.entityList[0].title;
        ref.instance.background = background;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
      }

        break;
      case 'CustomPublication': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(CarrouselGeneralComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.data = info.publication;
        ref.instance.title = 'Publicaciones';
        ref.instance.background = background;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
      }

        break;
      case 'Noticias con resumen': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(PostComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.data = info.entityList[0].entity;
        ref.instance.title = info.entityList[0].title;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
      }

        break;
      case 'Carrousel':
        if (info.entityList[0].entity) {
          let factory = this.componentFactoryResolver.resolveComponentFactory(CarrouselGeneralComponent);
          let ref = (this.viewContainerRefA(index)).createComponent(factory);
          ref.instance.data = info.entityList[0].entity;
          ref.instance.title = info.entityList[0].title;
          ref.instance.background = background;
          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.changeDetectorRef.detectChanges();
        }
        break;
      case 'Cards':
        let factory = this.componentFactoryResolver.resolveComponentFactory(CardsGeneralDosComponent);
        let ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.data = info.socialNetwork.socialNetworkItem;
        ref.instance.title = info.socialNetwork.title;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
        break;
      case 'Lista de links':
        if (info.entityList[0].entity) {
          const factory = this.componentFactoryResolver.resolveComponentFactory(ListaDeLinksComponent);
          const ref = (this.viewContainerRefA(index)).createComponent(factory);
          ref.instance.data = info.entityList[0].entity;
          ref.instance.title = info.entityList[0].title;
          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.instance.background = background;
          ref.changeDetectorRef.detectChanges();
        }
        break;

      case 'Video + Formulario (en ingles)':

        //si esto rompe posiblemente se tenga que cambiar de "linkCode" a "link_video" 
        if (info.entityList[0].linkCode) {

          const factory = this.componentFactoryResolver.resolveComponentFactory(VideoMasFormularioComponent
          );
          const ref = (this.viewContainerRefA(index)).createComponent(factory);
          ref.instance.linkCode = info.entityList[0].linkCode;
          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.instance.title = info.entityList[0].title;
          ref.instance.background = background;
          ref.instance.idioma = 'en';
          ref.instance.entityId = info.entityList[0].id;
          ref.changeDetectorRef.detectChanges();

        }
        break;
      case 'Video + Formulario (en español)':
        if (info.entityList[0].linkCode) {
          const factory = this.componentFactoryResolver.resolveComponentFactory(VideoMasFormularioComponent
          );
          const ref = (this.viewContainerRefA(index)).createComponent(factory);
          ref.instance.linkCode = info.entityList[0].linkCode;
          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.instance.title = info.entityList[0].title;
          ref.instance.background = background;
          ref.instance.entityId = info.entityList[0].id;
          ref.instance.idioma = 'es';
          ref.changeDetectorRef.detectChanges();

        }
        break;
      case 'TextItem': {

        const factory = this.componentFactoryResolver.resolveComponentFactory(TextItemGeneralComponent);
        const ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.instance.data = info.title;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.i = index;
        ref.changeDetectorRef.detectChanges();

      }
        break;

      case 'CustomForm': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(FormContactoComponent);
        const ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();

      }
        break;
      case 'Diary': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(CustomDiaryGeneralComponent);
        const ref = (this.viewContainerRefA(index)).createComponent(factory);
        if (index == 2) {
          width = 4;
        }
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.data = info.diary[0].diaryItem;
        ref.instance.title = info.diary[0].title;
        ref.instance.width = width;
        ref.changeDetectorRef.detectChanges();

      }
        break;
      case 'CustomStats': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(CustomStatsGeneralComponent);
        const ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.data = info.CustomStats;
        ref.instance.width = width;
        ref.changeDetectorRef.detectChanges();

      }
        break;
      case 'Cabecera': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(CabeceraComponent);
        const ref = (this.viewContainerRefA(index)).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.title = info.entityList[0].title;
        ref.instance.slider = info.entityList[0].entity;
        ref.instance.background = info.entityList[0].background;
        ref.instance.path = info.entityList[0].path;
        ref.instance.width = width;
        ref.instance.noticesLinkTitle = info.entityList[0].noticesLinkTitle;
        ref.instance.noticesLink = info.entityList[0].noticesLink.systemTitle;
        ref.instance.cabeceraButtons = info.entityList[0].cabeceraButtons;
        ref.changeDetectorRef.detectChanges();

      }
        break;


    }






  }
*/
  viewContainerRefA(index: number): any {
    switch (index) {
      case 1:
        return this.viewContainerRef1;
      case 2:
        return this.viewContainerRef2;
      case 3:
        return this.viewContainerRef3;
      case 4:
        return this.viewContainerRef4;
      case 5:
        return this.viewContainerRef5;
      case 6:
        return this.viewContainerRef6;
      case 7:
        return this.viewContainerRef7;
      case 8:
        return this.viewContainerRef8;
      case 9:
        return this.viewContainerRef9;
      case 10:
        return this.viewContainerRef10;
      case 11:
        return this.viewContainerRef11;
      case 12:
        return this.viewContainerRef12;
      case 13:
        return this.viewContainerRef13;
      case 14:
        return this.viewContainerRef14;
      case 15:
        return this.viewContainerRef15;
      case 16:
        return this.viewContainerRef16;
      case 17:
        return this.viewContainerRef17;
      case 18:
        return this.viewContainerRef18;
      case 19:
        return this.viewContainerRef19;
      case 20:
        return this.viewContainerRef20;
      default:
        // 
        break;
    }
  }


}
